import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@environments/environment";
import { ApiResponse } from "@app/_models";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MobileAutomationService {
  private _baseUrl: string;

  constructor(private http: HttpClient) {
    this._baseUrl = environment.apiUrl;
  }

  addMobileLocator(searchParams): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this._baseUrl}mobileLocators`, searchParams);
  }

  addMobileLocatorForceCreate(searchParams): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this._baseUrl}mobileLocators?forceCreate=true`, searchParams);
  }

  editMobileLocator(searchParams): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this._baseUrl}mobileLocators`, searchParams);
  }

  deleteMobileLocator(locatorId) {
    return this.http.delete<ApiResponse>(`${this._baseUrl}mobileLocators/${locatorId}`);
  }

  // Page-Label APIs
  getAllPageLabelsByProject(projectId: any): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}mobileLocators/pageLabels/project/${projectId}`);
  }

  getMobileLocators(searchParams: any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}mobileLocators/list`, searchParams);
  }

  getMobileLocatorsById(locatorId: any): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}mobileLocators/${locatorId}`);
  }

  getMobileLocatorsByProjectId(projectId: any): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}mobileLocators/project/${projectId}`);
  }

  addMobileInstruction(searchParams: any): Observable<any> {
    return this.http.post<ApiResponse>(`${this._baseUrl}mobileInstructions`, searchParams);
  }

  updateMobileInstruction(searchParams: any): Observable<any> {
    return this.http.put<ApiResponse>(`${this._baseUrl}mobileInstructions`, searchParams);
  }

  deleteMobileInstruction(instructionID) {
    return this.http.delete<ApiResponse>(`${this._baseUrl}mobileInstructions/${instructionID}`);
  }

  getMobileInstruction(searchParams: any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}mobileInstructions/list`, searchParams);
  }

  getMobileInstructionByEndpoint(endpointId: any): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}endPointMobileInstructions/endPoint/${endpointId}`);
  }

  updateMobileInstructionAssociation(data: any, endpointId: any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}endPointMobileInstructions/endPoint/${endpointId}/associate`, data);
  }

  postOperationsMobileInstruction(data: any, instructionid: any){
    return this.http.post<any>(`${this._baseUrl}endPointMobileInstructions/${instructionid}/postOperations`, data);
  }

  getPassFailData(instructionid: any){
    return this.http.get<any>(`${this._baseUrl}endPointMobileInstructions/${instructionid}/postOperations`);
  }

  clearPostOperation(instructionid) {
    return this.http.delete<any>(`${this._baseUrl}endPointMobileInstructions/${instructionid}/postOperations`);
  }

  updateEndpointMobileInstruction(instructionId, data): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this._baseUrl}endPointMobileInstructions/${instructionId}`, data);
  }

  getMobileInstructionAssociatedEndpoint(instructionId): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this._baseUrl}mobileInstructions/${instructionId}/endpoints`);
  }

  getSelectedMobileInstructionScreenshot(gridFsId) {
    return this.http.get<ApiResponse>(`${this._baseUrl}file/fileContent/${gridFsId}`);
  }

  getSelectedMobileInstructionScreenshotS3(body) {
    return this.http.post<ApiResponse>(`${this._baseUrl}file/mobile/fileContent`, body);
  }

  getMobileExecutionList(searchParams: any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}mobileExecutions/list`, searchParams);
  }

  getUsersList() {
    return this.http.get<any>(`${environment.apiUrl}users`);
  }

  getMobileLocatorHistory(endpointId: any) {
    return this.http.post<ApiResponse>(`${this._baseUrl}historyLog/endpoint/${endpointId}/mobileLocator`, {});
  }

  getMobileInstructionHistory(endpointId: any) {
    return this.http.post<ApiResponse>(`${this._baseUrl}historyLog/endpoint/${endpointId}/mobileInstruction`, {});
  }
}
